import React, { useState } from "react";
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { motion } from "framer-motion";
import { useSelector, useDispatch } from "react-redux";

import { contentActions } from "../../store/content-slice";

import { images } from "../../constants";
import "./Navbar.scss";

const Navbar = (props) => {
  const [toggle, setToggle] = useState(false);

  const dispatch = useDispatch();
  const { content, selectedLanguage } = useSelector((state) => state.content);

  const { navbarLinks } = content.navbar;

  const { changeLanguage } = contentActions;

  let lang = localStorage.getItem("selectedLang");
  if (lang) {
    dispatch(changeLanguage(lang));
  } else {
    localStorage.setItem("selectedLang", selectedLanguage);
  }

  const handleChangeLanguage = (e) => {
    dispatch(changeLanguage(e.target.textContent));

    localStorage.removeItem("selectedLang");
    localStorage.setItem("selectedLang", e.target.textContent);
  };

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        {/* <img src={images.logo} alt="logo" /> */}
      </div>
      <ul className="app__navbar-links">
        {navbarLinks.map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>
      <div className="app__navbar-languages">
        <button onClick={handleChangeLanguage}>TR</button>
        <div className=""></div>
        <button onClick={handleChangeLanguage}>EN</button>
      </div>
      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} />

        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transition={{ duration: 0.85, ease: "easeOut" }}
          >
            <HiX onClick={() => setToggle(false)} />
            <ul>
              {navbarLinks.map((item) => (
                <li key={item}>
                  <a href={`#${item}`} onClick={() => setToggle(false)}>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
